function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.06 9c0-1.1.9-2 2-2H46a2 2 0 012 2v4.34H9.06v5.43H48v12.5a2 2 0 01-2 2H11.06a2 2 0 01-2-2V27H39v-6H9.06V9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 15.15a2 2 0 00-2 2v4.34h38.94v-4.34a2 2 0 00-2-2H2zm36.94 11.77H0v12.5c0 1.1.9 2 2 2h34.94a2 2 0 002-2v-12.5zM7 37.5a2.5 2.5 0 110-4 2.5 2.5 0 110 4z"
})));